module.exports = __webpack_public_path__ + "static/assets/8bce2aa48a3393eb61cc3af660946d67.png";